import { IActivationEmailResponse } from '@/models/integrations-activation-emails';

import APIService from '.';

export default class ActivationEmailService extends APIService {
  getActivationEmail() {
    return this.get<IActivationEmailResponse>(
      '/admin/business/customer-acquisition'
    );
  }

  putActivationEmailEnabled(enabled: boolean) {
    return this.put('/admin/business/customer-acquisition', {
      enabled
    });
  }
}
